import { bfsUserWebHttp, otmsHttp } from '@/utils/http/index'

const bfsMerchant = '/bfs_merchant'

/**
 * 项目组织列表
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9210
 */
export function getOrganization(data, params) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/organization/page',
    method: 'post',
    data,
    params
  })
}

/**
 * 新建项目
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9306
 */
export function createOrganization(data) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/organization/create',
    method: 'post',
    data,
  })
}
/**
 * 修改项目
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9306
 */
export function createOrganizationUpsert(data) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/organization/upsert',
    method: 'post',
    data,
  })
}

/**
 * 分页查询绑定下级的货主列表
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/18001
 */
export function getSubordinate(data, params) {
  return otmsHttp.post({
    url: '/customer/bind_children_page',
    method: 'post',
    data,
    params
  })
}

/**
 * 合同项目列表
 * https://yapi.ops.yunlizhi.cn/project/442/interface/api/14442
 */
export function getContractProject (data) {
  return bfsUserWebHttp.post(`${bfsMerchant}/manager/merchant/project/page`,data)
}

/**
 * 添加合同项目
 * https://yapi.ops.yunlizhi.cn/project/442/interface/api/14436
 */
 export function addContractProject (data) {
  return bfsUserWebHttp.post(`${bfsMerchant}/manager/merchant/project/add`,data)
}

/**
 * 修改合同项目
 * https://yapi.ops.yunlizhi.cn/project/442/interface/api/14440
 */
 export function updateContractProject (data) {
  return bfsUserWebHttp.post(`${bfsMerchant}/manager/merchant/project/update`,data)
}

/**
 * 删除合同项目
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/20701
 */
 export function deleteContractProject(data) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/organization/delete_contract_project',
    method: 'post',
    data,
  })
}

/**
 * 合同项目详情
 * https://yapi.ops.yunlizhi.cn/project/442/interface/api/14438
 */
 export function getProjectDetail (data) {
  return bfsUserWebHttp.get(`${bfsMerchant}/manager/merchant/project/detail`,{},{
    params: data
  })
}

/**
 * 品牌列表
 * https://yapi.ops.yunlizhi.cn/project/442/interface/api/16517
 */
 export function getBrandList (data) {
  return bfsUserWebHttp.post(`${bfsMerchant}/manager/merchant/brand/page`,data)
}

// 关联用户
export function getUserListByName (data) {
  return bfsUserWebHttp.post(`/bfs-user/oa_user/by_name`,data)
}

/**
 * 自动应用新增/编辑
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/25517
 */
 export function upsertProjectContent (data) {
  return otmsHttp.post('/crm-plus/project_content/upsert', data)
}

/**
 * 自动应用详情
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/25526
 */
 export function getProjectContentDetail (data) {
  return otmsHttp.post('/crm-plus/project_content/detail', data)
}

/**
 * 货主SKU分页
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8750
 */
 export function fetchSkuPage(data) {
  return otmsHttp.post('/customer/sku/page', data, {
    params: {
      page: 1,
      size: 100
    }
  })
}

/**
 * 货主站点列表
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/25931
 */
 export function fetchStationPage(data) {
  return otmsHttp.post('/customer/station/es_page', data, {
    params: {
      page: 1,
      size: 100
    }
  })
}

/**
 * 线路查询
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/26021
 */
 export function customerLineList(data) {
  return otmsHttp.post('/base_plus/line/customer_line/list', data, {
    params: {
      page: 1,
      size: 1000
    }
  })
 }

 /**
 * 项目查询
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/25310
 */
  export function projectPage(data,params) {
    return otmsHttp.post('/crm-plus/project/page', data, {
      params
    })
  }

  /**
 * 项目更新/创建
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/25301
 */
   export function projectUpsert(data) {
    return otmsHttp.post('/crm-plus/project/upsert', data)
  }

    /**
 * 项目启用/禁用
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/25328
 */
     export function projectStatusUpsert(data) {
      return otmsHttp.post('/crm-plus/project/status/update', data)
     }
  
  /**
 * 查询货主(客户)列表
 */
 export function customerList(data, params) {
  return otmsHttp.post('/crm_plus/customer/page', data, { params });
}
